module.exports = ".outermost{\r\n    background-color:white;\r\n}"